<p-confirmdialog lOutsideClick [key]="key" styleClass="status-confirm-dialog" maskStyleClass="status-confirm-mask">
	<ng-template pTemplate="headless" let-message let-onAccept="onAccept">
		<div
			open
			class="w-full max-w-[34rem] md:max-w-[36rem] flex flex-col gap-4 md:gap-6 p-5 md:p-8 rounded-3xl bg-gradient-modal shadow-modal"
			aria-modal="true"
			[attr.aria-label]="message.header"
		>
			<h2 class="m-0 text-lSecondary text-lg font-normal leading-tight">{{ message.header }}</h2>

			<div class="w-full h-px bg-lFog/[0.22]"></div>

			<p class="m-0 text-lWhite text-base leading-[1.35] tracking-[0.01em]">{{ message.message }}</p>

			<button
				lButton
				type="button"
				[bRadius]="buttonRadiusEnum.LARGE"
				[bType]="buttonTypesEnum.PRIMARY"
				(click)="onAccept()"
			>
				{{ message.acceptLabel || defaultActionLabel }}
			</button>
		</div>
	</ng-template>
</p-confirmdialog>
